import type { CommissionFundingBatchNode } from "../funding/types";
import { commissionCampaignFixtures, commissionPartnerFixtures } from "./fixtures";
import { commissionLineFixtures } from "./lineFixtures";

function partnerForCampaign(campaignId: string) {
  const campaign = commissionCampaignFixtures.find((node) => node.id === campaignId);
  if (!campaign) {
    throw new Error(`Missing campaign fixture for ${campaignId}`);
  }

  const partner = commissionPartnerFixtures.find((node) => node.id === campaign.partner.id);
  if (!partner) {
    throw new Error(`Missing partner fixture for ${campaign.partner.id}`);
  }

  return partner;
}

export const commissionFundingBatchFixtures: CommissionFundingBatchNode[] = [
  {
    id: "commission-funding-batch-draft",
    status: "DRAFT",
    invoicePresentation: "DRAFT",
    totalAmountCents: 125000,
    lineCount: 1,
    issuedOn: null,
    dueOn: null,
    paidOn: null,
    workdayReference: null,
    createdAt: "2026-03-17T10:00:00Z",
    partner: partnerForCampaign("commission-campaign-2026-acme")
  },
  {
    id: "commission-funding-batch-invoiced",
    status: "INVOICED",
    invoicePresentation: "ISSUED",
    totalAmountCents: 98000,
    lineCount: 1,
    issuedOn: "2026-03-12",
    dueOn: "2026-04-11",
    paidOn: null,
    workdayReference: "WD-INV-2026-0142",
    createdAt: "2026-03-10T09:00:00Z",
    partner: partnerForCampaign("commission-campaign-2026-acme")
  },
  {
    id: "commission-funding-batch-funded",
    status: "FUNDED",
    invoicePresentation: "PAID",
    totalAmountCents: 200000,
    lineCount: 1,
    issuedOn: "2026-02-05",
    dueOn: "2026-03-07",
    paidOn: "2026-02-28",
    workdayReference: "WD-INV-2026-0098",
    createdAt: "2026-02-01T09:10:00Z",
    partner: partnerForCampaign("commission-campaign-2026-acme")
  }
];

export const commissionFundingBatchLineFixtures: Record<
  string,
  Array<{
    id: string;
    pgaId: string;
    personDisplayName: string;
    amountCents: number;
    fundingStatus: string;
  }>
> = {
  "commission-funding-batch-draft": [
    {
      id: commissionLineFixtures[0].id,
      pgaId: commissionLineFixtures[0].person.pgaId ?? "",
      personDisplayName: commissionLineFixtures[0].person.displayName,
      amountCents: commissionLineFixtures[0].amountCents,
      fundingStatus: "PENDING"
    }
  ],
  "commission-funding-batch-invoiced": [
    {
      id: commissionLineFixtures[1].id,
      pgaId: commissionLineFixtures[1].person.pgaId ?? "",
      personDisplayName: commissionLineFixtures[1].person.displayName,
      amountCents: commissionLineFixtures[1].amountCents,
      fundingStatus: "INVOICED"
    }
  ],
  "commission-funding-batch-funded": [
    {
      id: commissionLineFixtures[2].id,
      pgaId: commissionLineFixtures[2].person.pgaId ?? "",
      personDisplayName: commissionLineFixtures[2].person.displayName,
      amountCents: commissionLineFixtures[2].amountCents,
      fundingStatus: "FUNDED"
    }
  ]
};
